import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const adminAPI = {
  // Dashboard stats
  getDashboardStats: async () => {
    const response = await axios.get(`${BACKEND_URL}/api/admin/dashboard/stats`, getAuthHeaders());
    return response.data;
  },

  // Contact submissions
  getContacts: async (skip = 0, limit = 50) => {
    const response = await axios.get(
      `${BACKEND_URL}/api/admin/contacts?skip=${skip}&limit=${limit}`,
      getAuthHeaders()
    );
    return response.data;
  },

  getContactById: async (id) => {
    const response = await axios.get(`${BACKEND_URL}/api/admin/contacts/${id}`, getAuthHeaders());
    return response.data;
  },

  // Agent applications
  getAgents: async (skip = 0, limit = 50) => {
    const response = await axios.get(
      `${BACKEND_URL}/api/admin/agents?skip=${skip}&limit=${limit}`,
      getAuthHeaders()
    );
    return response.data;
  },

  getAgentById: async (id) => {
    const response = await axios.get(`${BACKEND_URL}/api/admin/agents/${id}`, getAuthHeaders());
    return response.data;
  },

  deleteContacts: async (ids) => {
    const response = await axios.post(`${BACKEND_URL}/api/admin/contacts/bulk-delete`, { ids }, getAuthHeaders());
    return response.data;
  },

  deleteAgents: async (ids) => {
    const response = await axios.post(`${BACKEND_URL}/api/admin/agents/bulk-delete`, { ids }, getAuthHeaders());
    return response.data;
  },

  getChats: async () => {
    const response = await axios.get(`${BACKEND_URL}/api/admin/chats`, getAuthHeaders());
    return response.data;
  },

  deleteChats: async (sessionIds) => {
    const response = await axios.post(`${BACKEND_URL}/api/admin/chats/bulk-delete`, { session_ids: sessionIds }, getAuthHeaders());
    return response.data;
  },

  sendInsightsNow: async () => {
    const response = await axios.post(`${BACKEND_URL}/api/admin/insights/send-now`, {}, getAuthHeaders());
    return response.data;
  },

  updateContactStatus: async (id, status) => {
    const response = await axios.patch(`${BACKEND_URL}/api/admin/contacts/${id}/status`, { status }, getAuthHeaders());
    return response.data;
  },
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('adminToken');
};

export const logout = () => {
  localStorage.removeItem('adminToken');
  window.location.href = '/admin/login';
};
